const actions = {
  UPDATE_SELECED_ACCOUNT: 'UPDATE_SELECED_ACCOUNT',

  GET_CURRENCY_ACCOUNTS: 'GET_CURRENCY_ACCOUNTS',
  GET_CURRENCY_ACCOUNTS_SUCCESS: 'GET_CURRENCY_ACCOUNTS_SUCCESS',
  GET_CURRENCY_ACCOUNTS_FAILURE: 'GET_CURRENCY_ACCOUNTS_FAILURE',

  SHOW_CURRENCY_LIST_MODAL: 'SHOW_CURRENCY_LIST_MODAL',

  CLOSE_CURRENCY_LIST_MODAL: 'CLOSE_CURRENCY_LIST_MODAL',

  ADD_ACCOUNT_BY_CURRENCY: 'ADD_ACCOUNT_BY_CURRENCY',
  ADD_ACCOUNT_BY_CURRENCY_SUCCESS: 'ADD_ACCOUNT_BY_CURRENCY_SUCCESS',
  ADD_ACCOUNT_BY_CURRENCY_FAILURE: 'ADD_ACCOUNT_BY_CURRENCY_FAILURE',

  GET_CLIENT_CA_BY_ID: 'GET_CLIENT_CA_BY_ID',
  GET_CLIENT_CA_BY_ID_SUCCESS: 'GET_CLIENT_CA_BY_ID_SUCCESS',
  GET_CLIENT_CA_BY_ID_FAILURE: 'GET_CLIENT_CA_BY_ID_FAILURE',
}
export default actions

export const updateSelectedAccount = value => {
  return {
    type: actions.UPDATE_SELECED_ACCOUNT,
    value,
  }
}

export const getAllCurrencyAccounts = token => {
  return {
    type: actions.GET_CURRENCY_ACCOUNTS,
    token,
  }
}

export const showCurrencyListModal = () => {
  return {
    type: actions.SHOW_CURRENCY_LIST_MODAL,
  }
}

export const closeCurrencyListModal = () => {
  return {
    type: actions.CLOSE_CURRENCY_LIST_MODAL,
  }
}

export const addAccountByCurrency = (value, token) => {
  return {
    type: actions.ADD_ACCOUNT_BY_CURRENCY,
    value,
    token,
  }
}

export const getCAofClientById = (value, token) => {
  return {
    type: actions.GET_CLIENT_CA_BY_ID,
    value,
    token,
  }
}
